import { render, staticRenderFns } from "./AvalonElementSettings.vue?vue&type=template&id=702931bd&scoped=true&"
import script from "./AvalonElementSettings.vue?vue&type=script&lang=js&"
export * from "./AvalonElementSettings.vue?vue&type=script&lang=js&"
import style0 from "./AvalonElementSettings.vue?vue&type=style&index=0&id=702931bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702931bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
